<template>
    <div class="truncate">
        <account-link
            v-if="row.accountNo !== ''"
            class="text-primary"
            :account-no="row.accountNo"
        >
            {{ row.accountNo }}
        </account-link>
        {{ row.name }}
    </div>
</template>

<script setup lang="ts">

import {computed, provide} from 'vue'
import AccountLink from '@/bookkeeping-account/AccountLink.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: any,
            context: {
                panelId: Number,
                panelPathSegment: String
            },
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const row = computed(() => {
    return props.params.data
})

</script>


<style scoped>

</style>
